module.exports = __webpack_public_path__ + "img/i-roles-1.f38c5079.png";